import React, { useEffect } from 'react';
import { sendTrackingInfo } from '@panel/commons';

function NormalFlowDraftToOnCreditsNoEcomNo(props) {
  const { postingId, isComplete } = props;
  const temporalRedirect = () => {
    window.location = `/publicarPasoPublicacion.bum?idaviso=${postingId}`;
  };

  useEffect(() => {
    sendTrackingInfo(
      'Mis avisos',
      `Publicar Aviso con Datos ${isComplete ? 'completos' : 'incompletos'}_sin credito-Intencion`
    );
    temporalRedirect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
}

export { NormalFlowDraftToOnCreditsNoEcomNo };
